import React from "react";
import { useNavigate } from "react-router-dom";

function AddNewButton({ title, toUrl, localStorageItemsToBeNulled }) {
  const navigate = useNavigate();

  const handleClick = () => {
    localStorageItemsToBeNulled?.forEach((item) => {
      localStorage.setItem(item, "null");
    });
    navigate(toUrl);
  };

  return (
    <button className="btn btn-outline-primary btn-sm" onClick={handleClick}>
      {title}
    </button>
  );
}

export default AddNewButton;
